"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _reactTreebeard = require("react-treebeard");

var _overrides = require("../../../utils/overrides");

var _Icon = _interopRequireDefault(require("../Icon"));

var _styles = require("../../../utils/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'Tree');

var _ref2 = /*#__PURE__*/_react.default.createElement(_Icon.default, {
  name: "chevron",
  size: "small"
});

var Tree = function Tree(_ref) {
  var overridesProp = _ref.overrides,
      id = _ref.id,
      classesProp = _ref.classes,
      onToggle = _ref.onToggle,
      onSelect = _ref.onSelect,
      nodes = _ref.nodes,
      customs = _ref.customs,
      canSelectParents = _ref.canSelectParents;
  var classes = (0, _overrides.useClasses)(useStyles, classesProp);

  var _useState = (0, _react.useState)(nodes),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      cursor = _useState4[0],
      setCursor = _useState4[1];

  (0, _react.useEffect)(function () {
    setData(nodes);
  }, [nodes]);
  var override = (0, _overrides.getOverrides)(overridesProp, Tree.overrides);
  var onToggleNode = (0, _react.useCallback)(function (node, toggled) {
    if (node.children) node.toggled = toggled;
    setData((0, _extends2.default)({}, data));
    onToggle && onToggle(node);
  }, [data, onToggle]);
  var onSelectNode = (0, _react.useCallback)(function (node) {
    if (cursor) cursor.active = false;
    if (canSelectParents || !node.children || !node.children.length) node.active = true;else node.active = false;
    if (cursor && node && data.id !== node.id) data.active = false;
    setData((0, _extends2.default)({}, data));
    setCursor(node);
    onSelect && onSelect(node);
  }, [canSelectParents, cursor, data, onSelect]);
  var treeStyle = (0, _react.useMemo)(function () {
    return {
      tree: {
        base: {
          listStyle: 'none',
          background: 'transparent',
          margin: 0,
          padding: 0
        },
        node: {
          base: {
            position: 'relative'
          },
          subtree: {
            listStyle: 'none',
            paddingLeft: '19px'
          }
        }
      }
    };
  }, []);
  var decorators = (0, _react.useMemo)(function () {
    return {
      Container: function Container(props) {
        var _classnames;

        if (customs.Container) return /*#__PURE__*/_react.default.createElement(customs.Container, props);
        var isSelectable = (canSelectParents || !props.node.children || !props.node.children.length) && !props.node.isDisabled;
        var nodeClasses = (0, _classnames2.default)(classes.node, (_classnames = {}, (0, _defineProperty2.default)(_classnames, "HoiPoi__Tree__".concat(id, "__node-id-").concat(props.node.id), id && props.node.id), (0, _defineProperty2.default)(_classnames, classes.toggled, props.node.toggled), (0, _defineProperty2.default)(_classnames, classes.active, props.node.active), (0, _defineProperty2.default)(_classnames, classes.empty, !props.node.children || !props.node.children.length), (0, _defineProperty2.default)(_classnames, classes.isDisabled, props.node.isDisabled), (0, _defineProperty2.default)(_classnames, classes.isSelectable, isSelectable), _classnames));

        var NodeIcon = /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
          className: classes.nodeIcon,
          onClick: !props.node.isDisabled ? props.onClick : undefined
        }, override.nodeIcon), customs.NodeIcon ? /*#__PURE__*/_react.default.createElement(customs.NodeIcon, props) : _ref2);

        var NodeItem = /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
          className: classes.nodeItem,
          onClick: !props.node.isDisabled ? function () {
            return onSelectNode(props.node);
          } : undefined
        }, override.nodeItem), customs.NodeItem ? /*#__PURE__*/_react.default.createElement(customs.NodeItem, props) : props.node.name);

        var Node = customs.Node ? /*#__PURE__*/_react.default.createElement(customs.Node, (0, _extends2.default)({}, props, {
          NodeIcon: NodeIcon,
          NodeItem: NodeItem
        })) : /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
          className: nodeClasses
        }, override.node), NodeIcon, NodeItem);
        return Node;
      }
    };
  }, [customs.Container, customs.NodeIcon, customs.NodeItem, customs.Node, canSelectParents, classes.node, classes.toggled, classes.active, classes.empty, classes.isDisabled, classes.isSelectable, classes.nodeIcon, classes.nodeItem, id, override.nodeIcon, override.nodeItem, override.node, onSelectNode]);
  return /*#__PURE__*/_react.default.createElement(_reactTreebeard.Treebeard, (0, _extends2.default)({
    data: data,
    onToggle: onToggleNode,
    decorators: decorators,
    style: treeStyle
  }, override.root));
};

Tree.overrides = ['root', 'node', 'nodeItem', 'nodeIcon'];
Tree.defaultProps = {
  nodes: {},
  customs: {}
};
process.env.NODE_ENV !== "production" ? Tree.propTypes = {
  id: _propTypes.default.any,
  onToggle: _propTypes.default.func,
  onSelect: _propTypes.default.func,
  nodes: _propTypes.default.shape({
    id: _propTypes.default.any,
    children: _propTypes.default.array,
    toggled: _propTypes.default.bool,
    active: _propTypes.default.bool,
    isSelectable: _propTypes.default.bool
  }),
  canSelectParents: _propTypes.default.bool,
  customs: _propTypes.default.shape({
    Container: _propTypes.default.func,
    Node: _propTypes.default.func,
    NodeIcon: _propTypes.default.func,
    NodeItem: _propTypes.default.func
  })
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(Tree);

exports.default = _default;